
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/burger",
      function () {
        return require("private-next-pages/burger.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/burger"])
      });
    }
  